const dataDialogs = {

    type: {
        new: 'new',
        edit: 'edit',
        view: 'view',
    },
    name: {
        groupDialog: 'groupDialog',
        trialVipDialog: 'trialVipDialog',
        vipDialog: 'vipDialog',
        useRecordDialog: 'useRecordDialog',
        pricePlanDialog: 'pricePlanDialog',
        joinClubDialog: 'joinClubDialog',
        companyDialog: 'companyDialog',
        medicalDialog: 'medicalDialog',
        companyVipDialog: 'companyVipDialog',
        addPointDialog: 'addPointDialog',
        occDialog: 'occDialog',
        systemEmailDialog: 'systemEmailDialog',
        feedbackDialog: 'feedbackDialog',
        surveyFeedbackDialog: 'surveyFeedbackDialog',
        addMedicalDialog: 'addMedicalDialog',
        downloadCalendar: 'downloadCalendar',
        downloadMissions: 'downloadMissions',
        editAgendaDialog: 'editAgendaDialog',
    }

};

export default dataDialogs;



// WEBPACK FOOTER //
// ./src/constants/dataDialogs.js